import { useRef } from 'react';
import PropTypes from 'prop-types';
import ReactAudioPlayer from 'react-audio-player';
import { FaUndo, FaUpload } from 'react-icons/fa';
import IconButton from '../../util/IconButton';
import { useAudioPromptHandlers } from './useAudioPromptHandlers';

function AudioPrompt({
  name,
  audioUrl,
  defaultAudioUrl,
  displayName,
  setPromptError,
  setShowPromptError,
}) {
  const inputRef = useRef();
  const {
    audioRef,
    isDefault,
    revertTitle,
    values,
    currentAudioUrl,
    updatePromptsInfo,
    onAudioLoad,
    onAudioChange,
    onRevertClick,
  } = useAudioPromptHandlers(
    name,
    audioUrl,
    defaultAudioUrl,
    setPromptError,
    setShowPromptError,
  );

  if (updatePromptsInfo) {
    values[name] = undefined;
    return null;
  }

  return (
    <>
      <div>
        <i>{displayName}</i>
      </div>
      <input
        data-testid={`${name}-input`}
        id={name}
        name={name}
        type="file"
        accept="audio/wav"
        ref={inputRef}
        onClick={() => {
          // clear the current value to allow the user to select the same file again
          inputRef.current.value = '';
        }}
        onChange={onAudioChange}
        style={{ display: 'none' }}
      />
      <ReactAudioPlayer
        data-testid={`${name}-audio-player`}
        src={
          values[name] === undefined
            ? currentAudioUrl
            : URL.createObjectURL(values[name])
        }
        controls
        controlsList="nodownload"
        onLoadedMetadata={onAudioLoad}
        ref={audioRef}
      />
      <div style={{ padding: 0, float: 'right' }}>
        <IconButton
          name={`upload-${name}`}
          icon={<FaUpload />}
          tooltip="Upload custom audio"
          title="Upload custom audio"
          onClick={() => inputRef.current.click()}
          variant="outline-secondary"
          style={{ float: 'right' }}
        />
        {!isDefault && (
          <IconButton
            name={`revert-${name}`}
            icon={<FaUndo />}
            tooltip={revertTitle}
            title={revertTitle}
            onClick={onRevertClick}
            variant="outline-secondary"
            style={{ float: 'right', marginRight: '0.25em' }}
          />
        )}
      </div>
    </>
  );
}

AudioPrompt.propTypes = {
  name: PropTypes.string,
  audioUrl: PropTypes.string,
  defaultAudioUrl: PropTypes.string,
  displayName: PropTypes.string,
  setPromptError: PropTypes.func,
  setShowPromptError: PropTypes.func,
};

export default AudioPrompt;
